import PropTypes from 'prop-types';
import React, { useCallback, memo } from 'react';
import { connect } from 'react-redux';

import connectOptions, { mergeProps } from '../../utils/connectOptions';
import config from '../../config';
import Popups from '../../components/Popup';
import { changeField } from '../../actions/dashboards';
import downloadFile from '../../utils/downloadFile';

const { main } = config;

const OutreachReportPopupContainer = ({ url, dates, popup, changeField }) => {
  const handleOk = useCallback(
    event => {
      event.preventDefault();

      const from = dates.get('from').format('YYYY-MM-DD');
      const to = dates.get('to').format('YYYY-MM-DD');

      downloadFile({
        url,
        params: { from, to },
      });

      const afterOk = popup.getIn(['props', 'onOk'], () => {});

      afterOk();
    },
    [url, dates, popup],
  );

  const handleChange = useCallback(
    event => {
      const { name: field, value } = event.target;

      changeField({ field, value });
    },
    [changeField],
  );

  return <Popups.OutreachReportPopup dates={dates} onChange={handleChange} onOk={handleOk} url={url} />;
};

OutreachReportPopupContainer.propTypes = {
  changeField: PropTypes.func.isRequired,
  dates: PropTypes.object.isRequired,
  popup: PropTypes.object.isRequired,
  url: PropTypes.string,
};

function mapStateToProps(state) {
  return {
    url: main.get('OutreachReport'),
    dates: state.dashboards.get('popupDates'),
  };
}

export { OutreachReportPopupContainer };
export default connect(
  mapStateToProps,
  { changeField },
  mergeProps,
  connectOptions,
)(memo(OutreachReportPopupContainer));
